export default __webpack_public_path__ + "8ecba50ff92f8e4dcbdb1d2ea5562bb4.svg";